export default "__VITE_ASSET__Q9tV2lfK__"